import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";
const formField = {
  lineNo: {
    type: "number",
    name: "lineNo",
    label: "CO Line No",
    errorMsg: "CO Line No is required.",
    required: true,
    disabled: true,
  },
  returnCode: {
    type: "select",
    name: "returnCode",
    label: "Return Code",
    errorMsg: "Return Code is required.",
    maxLength: 20,
    required: true,
  },
  skuCode: {
    type: "select",
    name: "skuCode",
    label: "SKU Code",
    maxLength: 50,
    errorMsg: "SKU Code is required.",
    required: true,
    editable: false,
  },
  parentSKUCode: {
    type: "text",
    name: "parentSKUCode",
    label: "Parent SKU",
    maxLength: 50,
  },
  packType: {
    type: "text",
    name: "packType",
    label: "Pack Type",
    maxLength: 10,
    disabled: true,
    required: true,
  },
  coQty: {
    type: "number",
    name: "coQty",
    label: "CO Qty",
    required: true,
  },
  qtyReceived: {
    type: "number",
    name: "qtyReceived",
    label: "Quantity Received",
    disabled: true,
  },
  // couom: {
  //   type: "select",
  //   name: "couom",
  //   label: "CO UOM",
  //   maxLength: 10,
  //   required: true,
  // },
  baseUOM: {
    type: "text",
    name: "baseUOM",
    label: "Base UOM",
    maxLength: 10,
    disabled: true,
  },
  mln: {
    type: "text",
    name: "mln",
    label: "MLN",
    maxLength: 20,
  },
  custOrdNbr: {
    type: "text",
    name: "custOrdNbr",
    label: "Customer Order Number",
    maxLength: 20,
  },
  doNumber: {
    type: "text",
    name: "doNumber",
    label: "DO Number",
    maxLength: 20,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  expiryDate: {
    type: "date",
    name: "expiryDate",
    label: "Expiry Date",
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
  },
};

const {
  lineNo,
  returnCode,
  skuCode,
  parentSKUCode,
  packType,
  coQty,
  qtyReceived,
  //couom,
  baseUOM,
  mln,
  custOrdNbr,
  doNumber,
  status,
  expiryDate,
  remark,
} = formField;

// export const detailRender=[
//     [lineNo, status],
//     [vendorCode, returnCode],
//     [skuCode, parentSKUCode],
//     [packType, coQty],
//     [baseUOM],
//     [qtyReceived, mln],
//     [custOrdNbr, doNumber],
//     [remark]
// ]

export const detailRender = [
  [lineNo, returnCode, parentSKUCode, status],
  [skuCode, packType, baseUOM,mln],
  [coQty, qtyReceived, custOrdNbr, doNumber],
  [expiryDate, remark],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  [returnCode.name]: Yup.string().nullable().required(returnCode.errorMsg),
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
  [parentSKUCode.name]: Yup.string().nullable().max(parentSKUCode.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
  [custOrdNbr.name]: Yup.string().nullable().max(custOrdNbr.maxLength),
  [doNumber.name]: Yup.string().nullable().max(doNumber.maxLength),
  [mln.name]: Yup.string().nullable().max(mln.maxLength),
  // [couom.name]: Yup.object()
  //   .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
  //   .nullable()
  //   .required(),
  [coQty.name]: Yup.number()
    .min(1, "CO Qty must be greater than 1")
    .integer()
    .required("CO Qty is required"),
});
